/**
 * CW module route definitions.
 *
 * Exports lazy-loaded page components and route paths for the
 * Connected Workspace module.  Consumed by the dynamic module route
 * loader in routes/index.tsx via import.meta.glob.
 *
 * Cross-References:
 *   - S-MOD.11: Frontend dynamic navigation
 *   - FR-MOD-001: Module Registry
 *   - ADR-016: CW as Runtime Module
 */
import { lazy } from 'react';

const UnifiedFiles = lazy(() => import('./pages/UnifiedFiles'));
const ActivityFeed = lazy(() => import('./pages/ActivityFeed'));
const ConnectionList = lazy(() => import('./pages/ConnectionList'));
const ConnectionDetail = lazy(() => import('./pages/ConnectionDetail'));
// CW-SF-M6 — Custom Objects admin page.
const SalesforceCustomObjects = lazy(() => import('./pages/SalesforceCustomObjects'));
// My Day sprint — MYD-8 + ADJ-6 Week view
const MyDay = lazy(() => import('./pages/MyDay'));
const WeekView = lazy(() => import('./pages/WeekView'));

export const slug = 'cw';

export const routes = [
  { path: 'files', element: UnifiedFiles },
  { path: 'activity', element: ActivityFeed },
  { path: 'connections', element: ConnectionList },
  { path: 'connections/:id', element: ConnectionDetail },
  { path: 'admin/salesforce/custom-objects', element: SalesforceCustomObjects },
  { path: 'my-day', element: MyDay },
  { path: 'my-day/week', element: WeekView },
];
